// Small reusable atoms used by both the New/Edit Deal form (Field,
// SectionHeader, ComputedField) and the Deal card (IconBtn, Kpi,
// CommitProgress). Each keeps the same prop shape and class strings as the
// original inline definitions in Deals.jsx — pure mechanical move so
// behavior + DOM are byte-equivalent.

export function IconBtn({ children, danger, testid, ...props }) {
  return (
    <button {...props} type="button"
      data-testid={testid}
      className={`p-1.5 rounded-sm hover:bg-slate-100 ${danger ? "text-rose-600 hover:text-rose-700" : "text-slate-500 hover:text-slate-800"}`}>
      {children}
    </button>
  );
}

export function SectionHeader({ children }) {
  return <div className="text-[10px] font-mono uppercase tracking-widest text-slate-500 border-b border-slate-100 pb-1.5 pt-3">{children}</div>;
}

export function Field({ label, children, className }) {
  return (
    <label className={`block ${className || ""}`}>
      <div className="text-[10px] font-mono uppercase tracking-widest text-slate-500 mb-1">{label}</div>
      {children}
    </label>
  );
}

/** Read-only computed value field. Used for auto-calculated metrics on the
 *  New/Edit Deal form (Cap Rate, LTV, Monthly Payment) so sponsors can't
 *  enter a Cap Rate that disagrees with NOI/Price and confuse investors. */
export function ComputedField({ value, helper, testid }) {
  return (
    <div>
      <div className="input-clean w-full font-mono bg-slate-50 text-slate-800 cursor-not-allowed select-text"
        data-testid={testid}>
        {value}
      </div>
      {helper && (
        <div className="text-[9px] font-mono uppercase tracking-widest text-slate-400 mt-1">{helper}</div>
      )}
    </div>
  );
}

export function Kpi({ label, value }) {
  return (
    <div className="rounded-sm bg-slate-50 px-2 py-1.5">
      <div className="text-[9px] font-mono uppercase tracking-widest text-slate-400">{label}</div>
      <div className="text-xs font-semibold text-slate-800 font-mono">{value}</div>
    </div>
  );
}

/** Inline commit-progress chip. Shows how much of the equity raise has
 *  been soft-committed by investors so far, plus a slim bar gradient. */
export function CommitProgress({ committed, target }) {
  const pct = Math.min(100, Math.round((committed / target) * 100));
  const color = pct >= 100 ? "bg-emerald-500" : pct >= 50 ? "bg-indigo-500" : "bg-slate-400";
  return (
    <div className="flex items-center gap-1.5 flex-1 min-w-0">
      <div className="flex-1 h-1.5 rounded-full bg-slate-100 overflow-hidden">
        <div className={`h-full ${color} transition-all`} style={{ width: `${pct}%` }} />
      </div>
      <span className="text-[10px] font-mono text-slate-500 shrink-0">{pct}%</span>
    </div>
  );
}
